import { getOrderId, getOrderingSystem, getSelectedOrder, getSelectedShop } from '../../selectors/tools';
import { getDecisionNodeAtPath, getSimplrAccountIdOfSelectedTicket } from '../../extractFromState';
import { commonOrdersPostQuery } from '../../api/orders/shared';
import {
  CHECK_ORDER_DATE_FULFILLED,
  CHECK_ORDER_DATE_PENDING,
  CHECK_ORDER_DATE_REJECTED,
  CHECK_ORDER_DATE_RESET,
} from '../../reducers/tools/decisionTree/checkOrderDate';
import { addEdgeToDecisionTreePath } from '../searchActions';

export const checkOrderDatePending = () => {
  return {
    type: CHECK_ORDER_DATE_PENDING,
  };
};

export const checkOrderDateFulfilled = (result) => {
  return {
    type: CHECK_ORDER_DATE_FULFILLED,
    result,
  };
};

export const checkOrderDateRejected = (error) => {
  return {
    type: CHECK_ORDER_DATE_REJECTED,
    error,
  };
};

export const resetCheckOrderDateStore = () => {
  return {
    type: CHECK_ORDER_DATE_RESET,
  };
};

export const checkOrderDate = (payload) => async (dispatch, getState) => {
  try {
    const state = getState();
    const node = getDecisionNodeAtPath(state);
    const selectedOrder = getSelectedOrder(state);
    const simplrAccountId = getSimplrAccountIdOfSelectedTicket(state);
    const shopName = getSelectedShop(state);
    const shopType = getOrderingSystem(state);
    const orderId = getOrderId(selectedOrder, shopType).toString();

    const options = {
      simplrAccountId,
      shopName,
      shopType: shopType,
      orderId,
      start: node.startDate,
      end: node.endDate,
    };
    dispatch(checkOrderDatePending());
    const response = await commonOrdersPostQuery('/checkOrderDatePeriod', {}, options);
    dispatch(checkOrderDateFulfilled(response));

    if (response) {
      if (response.withinThreshold) {
        dispatch(addEdgeToDecisionTreePath('within_threshold'));
      } else {
        dispatch(addEdgeToDecisionTreePath('outside_threshold'));
      }
    }
  } catch (e) {
    dispatch(checkOrderDateRejected(e));
  }
};
